module.exports = __webpack_public_path__ + "static/Unity_Tower_lower_floor_4Tenants_v2-536b4d23d095670f878538acae14fd48.png";